export default __webpack_public_path__ + "static/media/experience.9aa990f8.svg";